import React, { FC } from 'react'
import styled from 'styled-components'

// Usage of RenderStatusType will not break the build
// eslint-disable-next-line no-restricted-imports
import { RenderStatusType } from 'gqlTypes/expansiveTypes'

import TimeAgo from 'components/TimeAgo'
import Caption from 'components/Caption'
import { shortDateFormatter } from 'components/TimeAgo/TimeAgo'
import { getRenderStatus, RenderStatus } from 'utils/renderStatus'

export const MetaContainer = styled(Caption)`
  white-space: nowrap;
  margin: 0 0 0 ${({ theme }) => `${theme.space[2]}px`};
  font-size: 0.75rem;
`
interface MetaProps {
  renderStatus?: RenderStatusType
  date?: Date | number | string
}

const dateFormatter = (value: number, unit: string) => {
  if (unit === 'second') return 'now'
  return shortDateFormatter(value, unit) + ' ago'
}

const VersionMeta: FC<MetaProps> = ({ ...props }) => {
  const { renderStatus, children, date } = props
  const processedRenderStatus = renderStatus && getRenderStatus(renderStatus)

  const metaInfo = (renderStatus?: RenderStatus) => {
    switch (renderStatus) {
      case 'uploading':
        return 'Uploading document...'

      case 'processing':
        return 'Processing document...'

      case 'failed':
        return 'Processing failed...'

      case 'loading':
        return null

      default:
        return date ? (
          <TimeAgo date={date} live={false} formatter={dateFormatter} />
        ) : null
    }
  }

  return (
    <MetaContainer>
      {metaInfo(processedRenderStatus)}
      {children}
    </MetaContainer>
  )
}

export default VersionMeta
